import { format } from 'svelte-i18n';
import { get } from 'svelte/store';
import { translateTemplateTitle } from './xt1_helpers/template_helpers';

export const getDeviceStatusNameTrans = (name: string, status = null) => {
	const $format = get(format);
	let statusName = status?.vcName || name || '';
	let phase = '';
	const m = statusName.match(/^([abc])_(\w+)$/);
	if (m) {
		phase = `${$format('phase', { default: 'phase' })} ${m[1].toUpperCase()} `;
		statusName = m[2];
	}

	const nameTranslations = {
		power: $format('power', { default: 'power' }),
		voltage: $format('em_voltage', { default: 'voltage' }),
		voltmeter: $format('voltmeter', { default: 'voltmeter' }),
		digital: $format('label_digital', { default: 'digital' }),
		blinds: $format('label_blinds', { default: 'blinds' }),
		analog: $format('label_analog', { default: 'analog' }),
		brightness: $format('collapse_title_brightness', { default: 'brightness' }),
		color_temp: $format('label_color_temperature', {
			default: 'color temperature',
		}),
		color: $format('label_color', { default: 'color' }),
		concentration: $format('label_concentration', { default: 'concentration' }),
		sensor: $format('device_type_sensor', { default: 'sensor' }),
		valves: $format('label_valves', { default: 'valves' }),
		temperature: $format('title_chart_temperature', { default: 'Temperature' }),
		smoke: $format('prop_smoke', { default: 'smoke' }),
		humidity: $format('option_scene_weather_cond_humidity', {
			default: 'humidity',
		}),
		lux: $format('label_lux', { default: 'lux' }),
		motion: $format('motion', { default: 'motion' }),
		door: $format('title_door', { default: 'door' }),
		battery: $format('collapse_title_battery', { default: 'battery' }),
		garage: $format('icon_name_garage', { default: 'Garage' }),
		vibration: $format('prop_vibration', { default: 'vibration' }),
		distance: $format('title_chart_distance', { default: 'Distance' }),
		level: $format('label_level', { default: 'level' }),
		occupancy: $format('label_parking_spot', { default: 'Parking Spot' }),
		acceleration: $format('title_acceleration', { default: 'Acceleration' }),
		tilt: $format('collapse_title_tilt', { default: 'tilt' }),
		flood: $format('prop_flood', { default: 'Flood' }),
		last: $format('label_last', { default: 'last' }),
		'boost time': $format('label_boost_time', { default: 'boost time' }),
		target_temperature: $format('label_target_temperature', {
			default: 'Target temperature',
		}),
		current_temperature: $format('label_current_temperature', {
			default: 'Current temperature',
		}),
		thermostat_temperature: $format('label_thermostat_temperature', {
			default: 'Thermostat temperature',
		}),
		'valve position': $format('label_valve_position', {
			default: 'valve position',
		}),
		not_calibrated: $format('label_not_calibrated', {
			default: 'Not calibrated',
		}),
		position: $format('label_position', { default: 'position' }),
		illuminance: $format('label_illuminance', { default: 'illuminance' }),
		current: $format('current', { default: 'Current' }),
		switch: $format('label_switch', { default: 'switch' }),
		timer: $format('collapse_title_timer', { default: 'timer' }),
		schedule: $format('process_device_schedule', { default: 'schedule' }),
		frequency: $format('label_frequency', { default: 'frequency' }),
		freq: $format('label_frequency', { default: 'frequency' }),
		total: $format('em_overall', { default: 'overall' }),
		total_returned: $format('label_total_returned', {
			default: 'Total returned',
		}),
		reactive: $format('em_reactive_power', { default: 'Reactive power' }),
		act_power: $format('power', { default: 'power' }),
		aprt_power: $format('aprt_power', { default: 'Apparent power' }),
		total_act: $format('em_overall', { default: 'overall' }),
		total_act_ret: $format('label_total_returned', {
			default: 'total returned',
		}),
		pf: $format('em_power_factor', { default: 'Power factor' }),
		count: $format('label_count', { default: 'count' }),
		zone: $format('label_zone', { default: 'zone' }),
		'last report': $format('label_last_report', { default: 'last report' }),
		'click combinations': $format('label_click_combinations', {
			default: 'click combinations',
		}),
		air_time: $format('addon_peripheral_air_time', {
			default: 'Air time',
		}),
		bytes_sent: $format('addon_peripheral_bytes_sent', {
			default: 'Sent',
		}),
		bytes_recd: $format('addon_peripheral_bytes_recd', {
			default: 'Received',
		}),
		time_total: $format('addon_peripheral_time_total', {
			default: 'Total air time',
		}),
	};

	if (['input_0', 'input_1'].includes(statusName)) return '';

	return phase + (nameTranslations[statusName.split(':')[0]] || translateTemplateTitle(statusName));
};
